export default __webpack_public_path__ + "slices/main/assets/public/media/logos/hbr.31c0bab7c59342f22a5de0c4fe637526.png";